<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>{{title}}</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSubscribe">Confirm</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          class="box">

          <div class="form form1">
            <div class="item">
              <span class="item-title">Insured Period</span>
              <el-form-item
                ref="date"
                prop="date">
                <v-date-picker
                  v-model="date"
                  type="daterange"
                  disabled
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Title</span>
              <el-form-item>
                <v-select
                  v-model="formData.isrd_title"
                  :list="titleOptions"
                  disabled
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Last Name</span>
              <el-form-item
                ref="isrd_lst_nm"
                prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  disabled
                  uppercase />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">First Name</span>
              <el-form-item
                ref="isrd_fst_nm"
                prop="isrd_fst_nm">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  disabled
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Date of Birth</span>
              <el-form-item
                ref="isrd_dob"
                prop="isrd_dob">
                <v-birth-day
                  v-model="formData.isrd_dob"
                  disabled
                  class="birth"></v-birth-day>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Phone No.</span>
              <el-form-item
                ref="mobile_no"
              >
                <v-input
                  v-model="formData.mobile_no"
                  disabled></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Email</span>
              <el-form-item
                ref="email"
              >
                <v-input
                  v-model="formData.email"
                  disabled></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Brand</span>
              <el-form-item
                ref="mobile_brand_id"
                prop="mobile_brand_id"
              >
                <v-select
                  v-model="formData.mobile_brand_id"
                  :list="globalOptions.mobile_brand"></v-select>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Model</span>
              <el-form-item
                ref="mobile_model"
                prop="mobile_model"
              >
                <v-input v-model="formData.mobile_model"></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">IMEI</span>
              <el-form-item
                ref="imei"
                prop="imei"
              >
                <v-input
                  v-model="formData.imei"
                  :maxlength="17"
                  :minlength="13"></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Purchase Date</span>
              <el-form-item
                ref="mobile_buy_dt"
              >
                <v-date-picker
                  v-model="formData.mobile_buy_dt"
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Screen Image</span>
              <el-form-item
                ref="mobile_imei_path_id"
                prop="mobile_imei_path_id"
              >
                <v-upload
                  :card="true"
                  :fileData="formData.mobile_imei"
                  :otherData="{
                    target: 'mobile_imei',
                    idKey: 'mobile_imei_path_id',
                    nameKey: 'mobile_imei'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
          </div>

        </div>
      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleSubscribe">Confirm</v-button>
      </div>
    </div>
    <aside>
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
    <endorsement-dailog
      ref="endorsement"
      :form="endorsementForm"
      :orderId="orderId"
      @success="handleRefresh"></endorsement-dailog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addAccountRemark} from '@api/account'
import {mobileAdjustPolicy, mobileEndorsePolicy, mobileMakeRefund} from '@api/micropolicy'
import EndorsementDailog from '@/views/records/micropolicy/components/dialog/endorsement-dailog'
import dayjs from 'dayjs'

export default {
  name: 'SubscribeMembership',
  components:{
    EndorsementDailog
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    customer:{
      type:Object,
      default:()=>({})
    },
    form:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    },
    isAdjust:{
      type:Boolean,
      default:false
    },
  },
  data () {
    const checkImei = (rule, value, callback)=>{
      if(value.length<13){
        callback('最少輸入13位字符串')
      }
      callback()
    }
    return {
      date:[],
      formData:{
        isrd_title:'',
        isrd_lst_nm:'',
        isrd_fst_nm:'',
        isrd_dob:'',
        email:'',
        mobile_no:'',
        id_no:'',
        mobile_brand_id:'',
        mobile_model:'',
        imei:'',
        mobile_imei_path_id:'',
        mobile_imei:{},
        mobile_imei_file_id_pic:'',
        mobile_buy_dt:''
      },
      message:'',
      remarkList: [],
      lock:false,
      cardInputComplete:false,
      extraRules: {
        imei: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          { validator: checkImei, trigger: ['change', 'blur'] },
        ],
        mobile_model: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        mobile_brand_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        mobile_imei_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    remarkLogsData(){
      return this.remarkList||[]
    },
    title(){
      return this.isAdjust?'Adjust Policy':'Endorse Policy'
    },
    customerId() {
      return this.$route.query.customer_id
    },
    orderId() {
      let {id} =  this.$route.query||{}
      return id
    },
    endorsementForm(){
      return {...this.form,...this.formData}
    }
  },
  watch:{
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        let {policy_period,mobile_imei={}} = val||{}
        Object.keys(this.formData).some(key=>{
          if(val[key])
            this.formData[key] = val[key]
        })
        this.formData.mobile_imei_path_id = mobile_imei.id||''
        let arr = policy_period.split('to')
        let start_time = arr[0].split('-')
        let end_time = arr[1].split('-')
        let start_day =''
        let end_day =''
        if(start_time)
          start_day = start_time[2].trim()+'-'+start_time[1].trim()+'-'+start_time[0].trim()
        if(end_time)
          end_day = end_time[2].trim()+'-'+end_time[1].trim()+'-'+end_time[0].trim()
        this.date = [start_day,end_day]
      }
    },
  },
  mounted(){
    this.remarkList = this.remark
  },
  methods: {
    handlerUploadSuccess({ data, result, otherData }) {
      const { id } = data
      this.$set(this.formData, 'mobile_imei', data)
      this.$set(this.formData, 'mobile_imei_path_id', id)
    },
    handlerUploadDelete({ data, result, otherData }) {
      this.$set(this.formData, 'mobile_imei', null)
      this.$set(this.formData, 'mobile_imei_path_id', '')
    },
    handleCancel(){
      this.$emit('cancel')
    },
    handleRefresh(data){
      this.$emit('success',data)
    },
    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleSubscribe(){

      this.$refs.form.validate(async (valid,rules) => {
        if (valid) {
          if(this.isAdjust){
            this.network().mobileAdjustPolicy()
          }else {
            this.$refs.endorsement.changeDialog()
          }
        }else{
          this.scrollToValidDom(rules)
        }

      })
    },
    network() {
      return {
        mobileEndorsePolicy: async (params) => {
          const { data } = await mobileEndorsePolicy(params)
        },
        mobileAdjustPolicy: async (params) => {
          const { data } = await mobileAdjustPolicy({
            ...this.formData,
            order_id:this.orderId,
            hideMessage:true
          }).catch((err)=>{
            let {response} = err||{}
            let {data} = err.response||{}
            let {message_language,code} = data||{}
            let message = code==4806?`IMEI ${this.formData.imei} is already existing.`:message_language
            this.$ConfirmBox({
              isNewConfirm:true,
              width:500,
              title:code==4806?'Existing IMEI':'Error',
              confirmBtn:code==4806?'Refund':'OK',
              message: message,
              isRed:true,
            }).then(() => {
              if(code==4806){
                this.network().mobileMakeRefund()
              }
            })
          })
          this.$ConfirmBox({
            isNewConfirm:true,
            width:500,
            title:'Adjust Policy',
            confirmBtn:'Done',
            cancelBtn:'',
            isGreen:true,
            message: 'This policy has been adjusted. All documents will be regenerated.'
          }).then(() => {
            this.$emit('success',data)
          })
        },
        addAccountRemark: async () => {
          const {data} = await addAccountRemark({
            customer_id: this.customerId,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        },
        mobileMakeRefund: async () => {
          const {data} = await mobileMakeRefund({
            order_id: this.orderId,
          })
          this.$emit('success',{})
        },
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
